export default __webpack_public_path__ + "static/media/S1-Traits.ad4174ca.png";